<template>
  <div class="dashboard-card">
    <div class="card-header">
      <awesomeIcon icon="chart-bar" /> Verdeling over tijd
    </div>
    <div class="card-graph">
      <GChart
        :settings="{ packages: ['corechart'], language: 'nl-nl' }"
        :data="rows"
        :options="options"
        :events="chartEvents"
        type="ColumnChart"
      />
    </div>
    <div id="classtime-tooltip"></div>
  </div>
</template>

<script>
import { takeRight, slice, sumBy } from 'lodash-es';

export default {
  name: 'ClassTimeWidget',
  data() {
    return {
      options: {
        height: 300,
        colors: this.$store.state.colorScheme,
        isStacked: 'percent',
        legend: {
          position: 'none',
        },
        chartArea: {
          left: 80,
          top: 20,
          bottom: 20,
          right: 0,
          width: '100%',
          height: '100%',
        },
        hAxis: {
          textStyle: {
            fontSize: 12,
          },
        },
        tooltip: {
          trigger: 'none',
        },
      },
      columns: [
        {
          type: 'string',
          label: 'Date',
        },
        {
          type: 'number',
          label: 'Aandelen',
        },
        {
          type: 'number',
          label: 'Alternatieve Beleggingen',
        },
        {
          type: 'number',
          label: 'Converteerbare Obligaties',
        },
        {
          type: 'number',
          label: 'Liquiditeiten',
        },
        {
          type: 'number',
          label: 'Geldmarkt',
        },
        {
          type: 'number',
          label: 'Obligaties',
        },
        {
          type: 'number',
          label: 'Overige',
        },
        {
          type: 'number',
          label: 'Opties',
        },
        {
          type: 'number',
          label: 'Vastgoed',
        },
        {
          type: 'number',
          label: 'Beschermd Beleggen',
        },
        {
          type: 'number',
          label: 'Samengestelde Obligaties',
        },
      ],
      chartEvents: {
        onmouseover: this.setTooltipContent,
        onmouseout: () => { this.setTooltipContent(null); },
      },
    };
  },
  computed: {
    rows() {
      return [this.columns].concat(takeRight(this.$parent.totalsAsset, 11));
    },
  },
  methods: {
    setTooltipContent(object) {
      const tooltip = document.getElementById('classtime-tooltip');
      if (object !== null) {
        tooltip.style.display = 'block';
        tooltip.innerHTML = `<b>${this.rows[object.row + 1][0]} - ${this.columns[object.column].label}</b>: &euro; ${this.formatPrice(this.rows[object.row + 1][object.column], true)} (${this.formatPrice(((this.rows[object.row + 1][object.column] * 100) / sumBy(slice(this.rows[object.row + 1], 1))), true)}%)`;
      } else {
        tooltip.style.display = 'none';
      }
    },
  },
};
</script>
<style lang="scss" scoped>
  #classtime-tooltip {
    padding: 10px 20px;
    background-color: #fcf8e3;
    color: #8a6d3b;
    display: block;
    position: absolute;
    top: 10px;
    left: 10px;
    right: 10px;
    display: none;
    pointer-events: none;
    border-radius: $br;
  }
  .card-graph {
    padding-bottom: 10px;
    min-height: 300px;
  }
</style>
